module.exports = __webpack_public_path__ + "static/NOOBPUNKS_SHORT_LOGO-6879523fdef323c3160b60ce1e99c527.png";